import _ from 'lodash'

const ProperCase = function() {

  function link($scope, element, attr, ngModel) {
    ngModel.$parsers.push(_.startCase)
  }

  return {
    link: link,
    require: 'ngModel'
  }
}

export default ProperCase
